var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_dropdown/down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_dropdown/down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#738089",
    fillRule: "nonzero",
    id: "Down_Arrow_3_"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50003196,8 C7.32565721,8 7.151112,7.93483367 7.01798719,7.80466768 L0.199815057,1.13803574 C-0.066605019,0.877537096 -0.066605019,0.45570596 0.199815057,0.195373982 C0.466235133,-0.064957995 0.897654975,-0.0651246608 1.1639046,0.195373982 L7.50003196,6.39067505 L13.8361593,0.195373982 C14.1025794,-0.0651246608 14.5339992,-0.0651246608 14.8002489,0.195373982 C15.0664985,0.455872626 15.0666689,0.877703762 14.8002489,1.13803574 L7.98207673,7.80466768 C7.84895192,7.93483367 7.67440671,8 7.50003196,8 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.246aa885353c494434fc11e664232f62.svg";
export { ForwardRef as ReactComponent };